<template>
  <!-- 底部 -->
  <div class="footer">
    <div class="footer_top">
      <div>
        <a
          href="http://company.drcnet.com.cn/about.html"
          target="_blank"
          rel="noopener noreferrer"
        >关于我们</a>
        <span>|</span>
        <a
          href="http://misc.drcnet.com.cn/us/wangzsm.aspx"
          target="_blank"
          rel="noopener noreferrer"
        >网站声明</a>
        <span>|</span>
        <a
          href="http://company.drcnet.com.cn/lxwm.html"
          target="_blank"
          rel="noopener noreferrer"
        >联系我们</a>
        <span>|</span>
        <a href="http://www.drcnet.com.cn/www/int/" target="_blank" rel="noopener noreferrer">公司网站</a>
      </div>
      <span>Copyright©1998-{{nowYear}} DRCNet. All Rights Reserved 版权所有 国研网</span>

      <p style="display:flex;">
        <a
          target="_blank"
          href="https://beian.miit.gov.cn"
          style="padding-left:7px;color:#9fa2a8;font-size:14px;"
        >
          京ICP证030059号-6 中关村信用促进会会员证书
          <img
            src="../assets/img/ga.png"
            style="width:20px;height:20px;"
            alt
          />
        </a>
        <a
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010102005520"
          style="padding-left:7px;color:#9fa2a8;font-size:14px;margin-left:20px;"
        >
          京公网安备 11010102005520号
          <img src="../assets/img/ba.gif" alt />
        </a>
      </p>
    </div>
    <div class="footer_bottom">
      热线电话：
      <span>400-7070-678</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      nowYear: ""
    };
  },
  methods: {
    // 获取本地年份
    addDate() {
      let year = new Date().getFullYear();
      this.nowYear = year;
    }
  },
  created() {
    this.addDate();
  }
};
</script>

<style scoped lang="less">
/* 底部 */
.footer {
  width: 100%;
  height: 100px;
  background: #1c2025;
  display: flex;
  margin-top: 25px;
}

.footer_top {
  width: 100%;
  height: auto;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(84, 84, 84, 1);
  line-height: 26px;
  // 居中
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin-left: 29px;
  div {
    a {
      padding: 7px;
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #9fa2a8;
    }
  }
  span {
    padding: 7px;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #9fa2a8;
  }
  .phone {
    transform: translate(13%, 0);
    padding-left: 5px;
    width: 18px;
    height: 18px;
  }
}
.footer_bottom {
  width: 300px;
  height: auto;
  display: flex;
  align-items: center;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #9fa2a8;
  span {
    font-size: 24px;
    font-family: Arial;
    font-weight: 400;
    color: #2685e0;
  }
}
</style>





// WEBPACK FOOTER //
// src/components/footer.vue